export const PostsTypes = {
   SET_POSTS: "SET_POSTS",
   LOAD_POSTS: "LOAD_POSTS",

   LOAD_POSTS_START: "LOAD_POSTS_START",
   LOAD_POSTS_SUCCESS: "LOAD_POSTS_SUCCESS",
   LOAD_POSTS_FAILURE: "LOAD_POSTS_FAILURE",
};
